import React, { Component } from 'react';
import { EkoForm, EkoFormButton, EkoFormInputText, EkoFormSelect } from '../../components/elements/EkoForm';
import { Modal } from 'react-bootstrap';
import EkoModal from '../../components/elements/EkoModal';
import { toastr } from 'react-redux-toastr';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import Api from '../../util/Api';
import EkoImageUpload from '../../components/elements/form/EkoImageUpload';
import Resizer from 'react-image-file-resizer';

class AddCompanyBranch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: this.props.editData || this.defaultFormData(),
            showModal: false,
            saving: false,
            errors: {},
            formFields: {},
            users: [],
            user_ids: [],
        };
    }

    defaultFormData() {
        return {
            name: '', phone: '', email: '', address: '', city_id: '', county_id: '', address_code: '',
            logo: '', e_invoice_default: '', e_invoice_other: '', e_archive_default: '', e_archive_other: '',
            trade_register_number: '', mersis_no: '', sgk_kurum_tipi: '', sgk_mukellef_kodu: ''
        };
    }
    getUserList(){
        Api.get("/company/getUserList", (response, errors) => {
            if (errors) {
                toastr.error("Hata", "Kullanıcı listesi alınırken hata oluştu.");
            } else {
                this.setState({ users: response.data || [] });
            }
        });
    }

    componentWillMount() {
        this.setState({ formData: this.props.editData || this.defaultFormData(), errors: {} });
        this.getUserList();
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.editData?.user_ids){
            this.setState({ user_ids: nextProps.editData?.user_ids });
        }else{
            this.setState({ user_ids: [] });
        }
        this.setState({ formData: nextProps.editData || this.defaultFormData(), showModal: nextProps.showModal });
    }

    onSave() {
        let formData = this.state.formData;
        this.setState({ saving: true });
        if (formData.name && formData.name !== '' && formData.name!==null && formData.name !== undefined) {
            Api.put("/company/insertCompanyBranch", { formData }, (response, postErrors) => {
                if (postErrors) {
                    this.setState({ saving: false });
                    toastr.error("Hata", "Kayıt sırasında hata oluştu.");
                } else {
                    toastr.success("Başarılı", "Kayıt başarıyla eklendi.");
                    this.setState({ saving: false, showModal: false });
                    if (this.props.onSave) this.props.onSave();
                }
            });
        } else {
            toastr.error("Hata", "Lütfen zorunlu alanları doldurunuz.");
            this.setState({ saving: false });
        }
    }

    onCancel() {
        if (this.props.onCancel) this.props.onCancel();
    }

    setFieldChange(type, field, value) {
        let formData = this.state.formData;
        formData[field] = value;
        this.setState({ formData: formData });
    }

    setFieldMount(type, field) {
        let formFields = this.state.formFields;
        if (!formFields[type]) formFields[type] = [field];
        else formFields[type].push(field);
        this.setState({ formFields: formFields });
    }
    getCounties(id) {
        let counties = this.props.counties || [];
        return counties.filter(data => {
            return data.city_id === id;
        });
    }

    fileUploadHandler(image, fieldName, maxWidth, maxHeight) {
        if (image) {
            Resizer.imageFileResizer(
                image,
                maxWidth,
                maxHeight,
                "PNG",
                100,
                0,
                (uri) => {
                    const fd = new FormData();
                    fd.append("image", uri);

                    if (uri.size < 1000000) {
                        Api.post("/eInformation/upload", fd, (response, error) => {
                            if (response && response.status !== "fail") {
                                const formData = { ...this.state.formData, [fieldName]: response.imageUrl };
                                this.setState({ formData });
                                toastr.success("Yükleme Başarılı");
                            } else {
                                toastr.error((response || error).message || "Yükleme sırasında hata oluştu.");
                            }
                        });
                    } else {
                        toastr.error("Resim boyutu fazla büyük");
                    }
                },
                "blob"
            );
        }
    }

    render() {
        const formProps = {
            onChange: this.setFieldChange.bind(this, "data"),
            onMount: this.setFieldMount.bind(this, "data"),
            formData: this.state.formData,
            errors: this.state.errors
        };
        let cities = this.props.cities || [];
        let counties = this.getCounties(this.state.formData.city_id || "");
        return <EkoModal
            bsSize="xlg"
            showModal={this.state.showModal}
            title={this.state.formData.id ? "Şube Güncelle" : "Yeni Şube Ekle"}
            onHide={() => {
                this.setState({ showModal: false, formData: this.defaultFormData(), errors: {} });
                this.onCancel();
            }}
            onSave={() => {
                this.props.onSave();
            }}
            spinner={this.state.saving}>

            <EkoForm formId={"add_company_branch"}>

                <div className="row" style={{ padding: "5px" }}>
                    <div className="col-md-4"><EkoFormInputText required={true} labelMd={3} colMd={9} {...formProps} label="Şube Adı" id="name" /></div>
                    <div className="col-md-4"><EkoFormInputText labelMd={3} colMd={9} {...formProps} label="Telefon" id="phone" /></div>
                    <div className="col-md-4"><EkoFormInputText labelMd={3} colMd={9} {...formProps} label="Email" id="email" /></div>
                </div>

                <div className="row" style={{ padding: "5px" }}>
                    <div className="col-md-4"><EkoFormInputText labelMd={3} colMd={9} {...formProps} label="Adres" id="address" /></div>
                    <div className="col-md-4">
                        <EkoFormSelect labelMd={3} colMd={9} {...formProps} id="city_id" options={cities} searchable={true} defaultText="İl Seçiniz" label="İl" />
                    </div>
                    <div className="col-md-4">
                        <EkoFormSelect labelMd={3} colMd={9} {...formProps} id="county_id" options={counties} searchable={true} defaultText="İlçe Seçiniz" label="İlçe" />
                    </div>
                </div>

                <div className="row" style={{ padding: "5px" }}>
                    <div className="col-md-4"><EkoFormInputText labelMd={3} colMd={9} {...formProps} label="Adres Kodu" id="address_code" /></div>
                    <div className="col-md-4"><EkoFormInputText labelMd={3} colMd={9} {...formProps} label="Ticaret Sicil No" id="trade_register_number" /></div>
                </div>

                <div className="row" style={{ padding: "5px" }}>
                    <div className="col-md-4"><EkoFormInputText labelMd={3} colMd={9} {...formProps} label="Mersis No" id="mersis_no" /></div>
                    <div className="col-md-4"><EkoFormInputText labelMd={3} colMd={9} {...formProps} label="SGK Mükellef Kodu" id="sgk_mukellef_kodu" /></div>
                    <div className="col-md-4"><EkoFormInputText labelMd={3} colMd={9} {...formProps} label="SGK Kurum Tipi" id="sgk_kurum_tipi" /></div>
                </div>

                <div className="row" style={{ padding: "5px" }}>
                    <div className="col-md-3"><EkoFormInputText labelMd={4} colMd={8} {...formProps} label="E-Fatura Seri" id="e_invoice_default" /></div>
                    <div className="col-md-3"><EkoFormInputText labelMd={4} colMd={8} {...formProps} label="E-Fatura GDF Seri" id="e_invoice_other" /></div>
                    <div className="col-md-3"><EkoFormInputText labelMd={4} colMd={8} {...formProps} label="E-Arşiv Seri" id="e_archive_default" /></div>
                    <div className="col-md-3"><EkoFormInputText labelMd={4} colMd={8} {...formProps} label="E-Arşiv GDF Seri" id="e_archive_other" /></div>
                </div>

                <div className="row" style={{ padding: "5px" }}>
                    <div className="col-md-4">
                        <label className="control-label col-md-3">Logo</label>
                        <div className="col-md-9">
                            <EkoImageUpload
                                selectedImage={this.state.formData.logo}
                                onChange={(image) =>
                                    this.fileUploadHandler(image, "logo", 250, 150)
                                }
                                maxSize={1256000}
                                buttonText="Logo Yükle"
                                width={180}
                                height={180}
                            />
                        </div>
                    </div>
                </div>



                <Modal.Footer>
                    <div className="row buttonProccess2" style={{ padding: "5px" }}>
                        <EkoFormButton label={this.state.formData.id ? "Güncelle" : "Yeni Ekle"} faClass="fa fa-plus" isLoading={this.state.saving} onClick={this.onSave.bind(this)} />
                        <EkoFormButton label="İptal" className="btn" onClick={this.onCancel.bind(this)} />
                    </div>
                </Modal.Footer>

            </EkoForm>
        </EkoModal>;
    }
}

function mapStateToProps(state) {
    return {
        formData: state.data.formData,
        viewOptions: state.data.viewOptions,
        cities: state.data.cities,
        counties: state.data.counties,
    };
}

export default connect(mapStateToProps, actions)(AddCompanyBranch);